// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ReleaseCard__releaseCard___103DK{padding:25px;border-radius:8px;transition:all .3s ease-in-out}.ReleaseCard__releaseCard___103DK:hover{box-shadow:3px 3px 10px #d5d4cf;transform:translateY(-2px)}.ReleaseCard__date___2G0Mf{color:#c0beb8;font-weight:500;text-transform:uppercase}.ReleaseCard__titleLink___2hpdm{text-decoration:none}.ReleaseCard__desc___2UvD4,.ReleaseCard__title___33yxp{margin-top:8px}.ReleaseCard__desc___2UvD4{color:#6b6651}.ReleaseCard__link___3PWNR{margin-top:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"releaseCard": "ReleaseCard__releaseCard___103DK",
	"date": "ReleaseCard__date___2G0Mf",
	"titleLink": "ReleaseCard__titleLink___2hpdm",
	"desc": "ReleaseCard__desc___2UvD4",
	"title": "ReleaseCard__title___33yxp",
	"link": "ReleaseCard__link___3PWNR"
};
module.exports = ___CSS_LOADER_EXPORT___;
